import React from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthState } from '../context/AuthProvider.js'
import { SocketState } from '../context/SocketProvider'


const topBtn = {
  background: '#4caf50',
  color: '#fff',
  border: 'none',
  padding: '5px 12px',
  marginLeft: '6px',
  cursor: 'pointer',
  fontWeight: 'bold'
}

function TopActionBar() {
  const navigate = useNavigate()
    const { authState } = AuthState()
    const { socket } = SocketState()


  return (
    <table width="100%" cellPadding="6" style={{ background: '#2f7d32', color: '#fff' }}>
  <tbody>
    <tr>
      <td style={{ fontWeight: 'bold' }}>
        Date: 27-Dec-2025 ( RETAILER )
      </td>

      <td align="right">
        <button 
          style={topBtn}
          onClick={() => navigate('/createUser')}
        >
          Create
        </button>

        <button
          style={topBtn}
          onClick={() =>navigate('/reportUser')}
        >
          Report
        </button>

        <button
          style={topBtn}
          onClick={() => navigate('/balance-transfer')}
        >
          Balance Transfer
        </button>

        <button
          style={topBtn}
          onClick={() => navigate(-1)}
        >
          GoBack
        </button>
      </td>
    </tr>
  </tbody>
</table>
    )
}

export default TopActionBar
